"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowDown, ClipboardCheck, Phone } from "lucide-react";
export default function Werkwijze() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: graphicRef,
    isVisible: isGraphicVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  return <section id="werkwijze" className="relative bg-background pt-24 pb-0 md:pt-32 overflow-hidden flex flex-col items-center justify-center min-h-[80vh]">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-primary/5 rounded-full blur-3xl -z-10 opacity-50 pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 text-center max-w-4xl relative z-10 flex-grow flex flex-col justify-center">
        <div ref={headerRef} className={`transition-all duration-1000 ease-out flex flex-col items-center ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-medium mb-6">
            <ClipboardCheck className="w-4 h-4" />
            <span>Onze Werkwijze</span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-foreground tracking-tight mb-6">
            Stap voor stap naar de <br className="hidden md:block" />
            <span className="text-primary">juiste zorg</span>
          </h1>

          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-10 leading-relaxed">
            Bij CuraNova Zorg geloven we in een helder en zorgvuldig proces. Van
            uw eerste aanmelding tot de start van de persoonlijke ondersteuning
            thuis, wij begeleiden u persoonlijk en nemen de tijd om uw situatie
            echt te begrijpen.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full sm:w-auto">
            <Button asChild size="lg" className="w-full sm:w-auto rounded-full">
              <Link to="/ContactPage">
                Meld u aan voor zorg
                <ArrowDown className="w-4 h-4 ml-2" />
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto rounded-full bg-background/50 backdrop-blur-sm">
              <Link to="/ContactPage">
                <Phone className="w-4 h-4 mr-2 text-primary" />
                Bel voor overleg
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div ref={graphicRef} className={`mt-16 md:mt-24 flex flex-col items-center transition-all duration-1000 delay-300 ease-out ${isGraphicVisible ? "opacity-100" : "opacity-0"}`}>
        <div className="w-4 h-4 rounded-full border-4 border-background bg-primary shadow-sm z-10 relative" />
        <div className="w-px h-32 md:h-48 bg-gradient-to-b from-primary/40 via-primary/20 to-transparent -mt-2" />
      </div>
    </section>;
}